export default __webpack_public_path__ + "static/media/mute-icon-new.5236d078.svg";